import { PageContextUtils, UrlUtils } from "../../../../utils";

import { config as defaultConfig } from "../../default/Kambi/Config.resource";

const getSportUrl = () => {
  return UrlUtils.getCurrentOriginURLWithLang(window.location.origin);
};

const { clientPage } = PageContextUtils.getSurveyData();

export const links = {
  betFeed: "/spelfeed/",
  bettingHistory: "/spelhistorik/b/",
  bettingRules: "/sa-har-lagger-du-spel/regler-for-spel-new/",
  blog: "/Blog/",
  casinoUrl: "https://www.888casino.se/",
  casinoNativeUrl: "https://casino-se.onelink.me/HBKu/CrossSellSportToCasino",
  sportUrl: getSportUrl(),
  contactUs: "https://www.888.com/help/app/home/p/243/",
  help: "https://888-external-sv.custhelp.com/app/home/p/1085/",
  home: "/",
  liveChat:
    "https://888-external-sv.custhelp.com/app/chat/chat_launch?chanel=888se_sv_norm&ChRefId=3",
  liveChatVIP:
    "https://888-external-sv.custhelp.com/app/chat/chat_launch?chanel=888se_sv_vip&ChRefId=3",
  liveNow: "/livespel/",
  logoTypesRegulation: "https://www.888.se/ansvarsfullt-spelande/",
  logoTypesSjalvTest: "https://www.stodlinjen.se/#!/spelberoende-test-pgsi",
  logoTypesSpelPaus: "https://www.spelpaus.se/?scos=true",
  pokerUrl: "https://www.888poker.se/",
  pokerUrlAuthenticated: "https://www.888poker.se/open-client.htm",
  pokerNativeUrliOS:
    "https://poker-se-ios.onelink.me/g6gX/CrossSellSportToPokeriOS",
  pokerNativeUrlAndroid:
    "https://poker-se-ios.onelink.me/g6gX/CrossSellSportToPokerAndroid",
  promotions: "/kampanjer/",
  recommendations: "/rekommendationer/",
  madeForYou: {
    sv: "/skapadfordig/föridag/mfytoday/"
  },
  responsibleGaming: "https://www.888.se/ansvarsfullt-spelande/",
  startingSoon: "/borjar-snart/",
  survey: clientPage,
  pokerHistoryLink: "/app/pokerhistorik/",
  greenGaming: "https://greengaming.com/sv/"
};

export const config = {
  ...defaultConfig,
  logo_VIP: "sport_logo_VIP"
};
